export function getBastionApiBaseUrl(): string {
  const viteEnv =
    typeof import.meta !== "undefined" ? (import.meta as any).env : {};
  const processEnv = typeof process !== "undefined" ? (process as any).env : {};

  const url =
    viteEnv?.VITE_BASTION_API_URL ||
    processEnv?.BASTION_API_URL ||
    processEnv?.NEXT_PUBLIC_BASTION_API_URL;

  if (!url) {
    throw new Error(
      "Bastion API URL is not configured. " +
        "Set VITE_BASTION_API_URL, BASTION_API_URL, or NEXT_PUBLIC_BASTION_API_URL.",
    );
  }

  return String(url).replace(/\/+$/, "");
}

/**
 * Base URL of the telemetry query service.
 *
 * The service runs on its own instance behind a `telemetry.` subdomain.
 */
export function getTelemetryApiBaseUrl(): string {
  const viteEnv =
    typeof import.meta !== "undefined" ? (import.meta as any).env : {};
  const processEnv = typeof process !== "undefined" ? (process as any).env : {};

  const url =
    viteEnv?.VITE_TELEMETRY_API_URL || processEnv?.VITE_TELEMETRY_API_URL;

  if (!url) {
    throw new Error(
      "Telemetry API URL is not configured. " + "Set VITE_TELEMETRY_API_URL.",
    );
  }

  return String(url).replace(/\/+$/, "");
}
